"use client";
import { useAction } from "next-safe-action/hooks";
import type { ivitrackAction } from "./ivitrackAction";
import { useEffect } from "react";

type Props = {
  iid: string;
  ivitrackAction: typeof ivitrackAction;
};

export const SendIvitrackEvent = ({ iid, ivitrackAction }: Props) => {
  const { execute } = useAction(ivitrackAction, {});

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    execute({
      iid: iid as string,
    });
  }, []);

  return null;
};
